import * as $ from 'jquery';
import { sendEvent } from './Analytics';
declare global {
    interface Window { Cookiebot: any; }
}


export function initialize(): void {
    addListeners();
}

function addListeners(): void {
    document.addEventListener('DOMContentLoaded', function () {
        const cookiebot = (window as any).Cookiebot;
        if (!cookiebot?.consent?.statistics) {
            if (typeof (window as any).appInsights === 'object' && typeof (window as any).appInsights.config === 'object') {
                (window as any).appInsights.config.disableCookiesUsage = true;
            }
                    
    }
});
window.addEventListener('load', function () {
    const cookiebot = (window as any).Cookiebot;
    if (!cookiebot?.consent?.statistics) {
            ['ai_session', 'ai_user'].forEach(name => {
            if (document.cookie.split(';').some(c => c.trim().startsWith(name + '='))) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
            }
        });
        }
    });

    window.addEventListener("CookiebotOnDecline", (() => {
        window.Cookiebot?.changed && location.reload()
    }
    ));

    $('.search-result').on('click', function () {
        sendEvent('documentViewFromSearch', null, { pageTitle: this.dataset.pagetitle, documentType: this.dataset.documenttype })
    });
    $(document).on('submit', '.searchfield__container', function () {
        sendEvent('search', undefined, {query: $('.searchfield__input').val() as string });
    });
    $('.documents__link').on('click', function () {
        sendEvent('documentViewFromMenu', null, { pageTitle: this.innerText, documentType: this.dataset.documenttype })
    });

    function findForm(element) {
        return element.querySelector("form");
    }

    var trackedDynamicsForms = document.querySelectorAll('.dynamics-form');
    trackedDynamicsForms.forEach(function (element) {
        var intervalId = window.setInterval(function () {
            let form = findForm(element);
            if (form && element instanceof HTMLElement && element.dataset.formname) {
                clearInterval(intervalId)
                form.addEventListener('submit', function () {
                    sendEvent('form_submitted', undefined, { formName: element.dataset.formname, typeOfForm: "Dynamics" });
                });
            }
        }, 2000);

    });
}

